export enum ConsultationStatus {
  Pending = 'pending',
  Prescribed = 'prescribed',
  Incomplete = 'incomplete',
  Disqualified = 'disqualified',
  Canceled = 'canceled',
}
